export const resolveDefaultCompetitionOrganizerUserIDs = (organizer, authUser) => {
  const organizerUsers = Array.isArray(organizer?.organizerUsers) ? organizer.organizerUsers : [];
  const currentUserID = Number(authUser?.user?.userID ?? authUser?.user?.ID ?? authUser?.user?.userObj?.userID ?? authUser?.user?.userObj?.ID ?? 0);
  const currentUserEmail = String(authUser?.user?.email ?? authUser?.user?.userObj?.email ?? '').trim().toLowerCase();

  return organizerUsers
    .filter((organizerUser) => {
      const organizerUserID = Number(organizerUser?.organizerUserID ?? 0);
      if (organizerUserID <= 0) {
        return false;
      }

      const organizerUserUserID = Number(organizerUser?.userID ?? 0);
      const organizerUserEmail = String(organizerUser?.email ?? '').trim().toLowerCase();

      if (currentUserID > 0 && organizerUserUserID === currentUserID) {
        return true;
      }

      return currentUserEmail !== '' && organizerUserEmail !== '' && organizerUserEmail === currentUserEmail;
    })
    .map((organizerUser) => Number(organizerUser.organizerUserID));
};

export const normalizeCompetitionOrganizerUserIDs = (values) => {
  if (!Array.isArray(values)) {
    return [];
  }

  return [...new Set(values.map((value) => Number(value)).filter((value) => value > 0))];
};